import request from './request'

export default {
  list(data) {
    return request.post('/customerService/list', data)
  },
  info(data) {
    return request.post('/customerService/info', data)
  },
  save(data) {
    return request.post('/customerService/save', data)
  },
  enable(data) {
    return request.post('/customerService/enable', data)
  },
  disable(data) {
    return request.post('/customerService/disable', data)
  },
  delete(data) {
    return request.post('/customerService/delete', data)
  },
}
